import * as serviceWorker from "./serviceWorker";

import { Provider } from "react-redux";
import React from "react";
import { useEffect } from "react";
import store from "./services/store";

import CheckVersion from "./components/CheckVersion";
import InAppNotification from "./components/Mobile/InAppNotification";
import PWARepeatPrompt from "./components/Mobile/PWARepeatPrompt";
import { Offline, Online } from "react-detect-offline";
import OfflineComponent from "./components/Mobile/OfflineComponent";
import CustomCssProvider from "./components/CustomCssProvider";
import PWAInstallation from "./components/Mobile/PWAInstallation";
import { ensureCsrfCookie } from "./services/csrf";
const polling = {
	enabled: false,
};

const MyContext = React.createContext();


const Root = ({ children, initialState = {} }) => {
	useEffect(() => {
		ensureCsrfCookie().catch(() => {
			// optional: silent fail, retry later
		});
	}, []);

	return (
		<React.Fragment>
			<Provider store={store(initialState)}>
				<MyContext.Provider value={initialState}>
					<CustomCssProvider />
					<Online polling={polling}>
						{children}
						<img
							className="cart-empty-img hidden"
							src="/assets/img/various/offline.png"
							alt="offline"
						/>
						<CheckVersion />
						<InAppNotification />
						<PWAInstallation />
						<PWARepeatPrompt />
					</Online>
					<Offline polling={polling}>
						<OfflineComponent />
					</Offline>
				</MyContext.Provider>
			</Provider>
		</React.Fragment>
	);
};


serviceWorker.register();

export default Root;
